export default {
    indexBigOccupationAreas:         { method: 'get',    url: 'big_occupation_areas' },
    createBigOccupationArea:         { method: 'post',   url: 'big_occupation_areas'},
    updateBigOccupationArea:         { method: 'put',    url: 'big_occupation_areas/{id}'},
    destroyBigOccupationArea:        { method: 'delete', url: 'big_occupation_areas/{id}'},
}